const DEFAULT_OPTIONS = {
  language: null,
  style: 'monokai-sublime'
};

export { DEFAULT_OPTIONS };
